import SVG from './SVG'
import * as T from './types'

const FlaredArrow = (props: T.ISVGProps) => (
  <SVG
    {...props}
    viewBox="0 0 20 14"
    d="M0 7.49985V6.49985C0 6.22371 0.223858 5.99985 0.5 5.99985H16.67L12.22 1.55985C12.1253 1.46597 12.0721 1.33817 12.0721 1.20485C12.0721 1.07153 12.1253 0.943736 12.22 0.849852L12.93 0.149852C13.0239 0.055196 13.1517 0.00195312 13.285 0.00195312C13.4183 0.00195312 13.5461 0.055196 13.64 0.149852L19.78 6.27985C19.9207 6.42037 19.9998 6.61101 20 6.80985V7.18985C19.9977 7.38827 19.9189 7.57813 19.78 7.71985L13.64 13.8499C13.5461 13.9445 13.4183 13.9978 13.285 13.9978C13.1517 13.9978 13.0239 13.9445 12.93 13.8499L12.22 13.1399C12.1259 13.0477 12.0729 12.9215 12.0729 12.7899C12.0729 12.6582 12.1259 12.532 12.22 12.4399L16.67 7.99985H0.5C0.223858 7.99985 0 7.77599 0 7.49985Z"
  />
)

export default FlaredArrow
